<template>
  <svg class="text-primary" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="77" height="77" viewBox="0 0 77 77">
    <defs>
      <filter id="Elipse_39" x="0" y="0" width="77" height="77" filterUnits="userSpaceOnUse">
        <feOffset dy="5" input="SourceAlpha"/>
        <feGaussianBlur stdDeviation="4" result="blur"/>
        <feFlood flood-opacity="0.161"/>
        <feComposite operator="in" in2="blur"/>
        <feComposite in="SourceGraphic"/>
      </filter>
    </defs>
    <g transform="translate(12 7)">
      <g transform="matrix(1, 0, 0, 1, -12, -7)" filter="url(#Elipse_39)">
        <g id="Elipse_39-2" data-name="Elipse 39" transform="translate(12 7)" fill="#4f3da5" stroke="#fff" stroke-width="2">
          <circle cx="26.5" cy="26.5" r="26.5" stroke="none"/>
          <circle cx="26.5" cy="26.5" r="25.5" fill="none"/>
        </g>
      </g>
      <path d="M10.169,11.016A1.7,1.7,0,0,0,8.474,9.321H7.626a3.389,3.389,0,0,0-3.39,3.39v2.542a3.389,3.389,0,0,0,3.39,3.39h.847a1.7,1.7,0,0,0,1.695-1.695Zm9.321,7.626a3.389,3.389,0,0,0,3.39-3.39V12.711a3.389,3.389,0,0,0-3.39-3.39h-.847a1.7,1.7,0,0,0-1.695,1.695v5.932a1.7,1.7,0,0,0,1.695,1.695ZM13.558,0C5.994,0,.243,6.293,0,13.558v.847a.847.847,0,0,0,.847.847h.847a.847.847,0,0,0,.847-.847v-.847a11.016,11.016,0,1,1,22.032,0h-.006c0,.129.006,8.777.006,8.777a2.239,2.239,0,0,1-2.239,2.239H16.948a2.542,2.542,0,0,0-2.542-2.542H12.711a2.542,2.542,0,0,0,0,5.084h9.624a4.781,4.781,0,0,0,4.781-4.781V13.558C26.874,6.293,21.122,0,13.558,0Z" transform="translate(12.941 12.942)" class="fill-current"/>
    </g>
  </svg>
</template>